// extracted by mini-css-extract-plugin
module.exports = {"gems_page":"GemsPage_gems_page__20-aL","loading_screen":"GemsPage_loading_screen__e2FZY","loading_text":"GemsPage_loading_text__1eqgu"};